import React from "react";
import website from "../asset/website-development.png";
import web from "../asset/web-application.png";
import ecommerce from "../asset/ecommerce-solution.png";
import app from "../asset/app-development.png";
import seo from "../asset/seo-service.png";
import smo from "../asset/smo-service.png";
import { NavLink } from "react-router-dom";

const services = [
  { name: "Website Development", icon: website, to: "/web-development" },
  { name: "Web Application", icon: web, to: "/webapplication" },
  { name: "Ecommerce Solution", icon: ecommerce, to: "/ecommerce" },
  { name: "App Development", icon: app, to: "/appdevelopment" },
  { name: "SEO Services", icon: seo, to: "/seo" },
  { name: "Social Media Marketing", icon: smo, to: "/smm" },
];

const ServiceCard = ({ name, icon, to }) => {
  return (
    <NavLink to={to} className="group flex h-full min-h-[180px] flex-col justify-between border-t-4 border-teal-700 bg-white p-5 shadow-[0_8px_30px_rgba(18,33,43,.07)] transition hover:-translate-y-1 hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600">
      <img src={icon} alt="" className="h-20 w-20 object-contain" />
      <div className="mt-5 flex items-end justify-between gap-3 font-bold text-slate-800"><span>{name}</span><span className="text-teal-700 transition group-hover:translate-x-1" aria-hidden="true">→</span></div>
    </NavLink>
  );
};

const ServicesSection = () => {
  return (
    <section className="bg-slate-50 py-16 sm:py-24">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[.2em] text-teal-700">What we do</p>
        <h2 className="mt-3 text-3xl font-bold text-slate-900 sm:text-4xl">
          Our services
        </h2>
        <p className="mt-4 max-w-2xl text-base leading-7 text-slate-600 sm:text-lg">
          We delve deep into understanding your business goals to create a
          custom web solution that sets you apart from the competition.
        </p>
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
          {services.map((service, index) => (
            <ServiceCard key={index} {...service} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
